import React from 'react'
import {
  Circle,
  Line,
  StepDescription,
  StepTextContainer,
  StepTitle,
  TimelineContainer,
  TitleContainer
} from './styles'
import Heading from '../../../../designSystem/Heading'
import Text from '../../../../designSystem/Text'

interface TimelineItemHeaderPropTypes {
  children: React.ReactNode
}

interface TimelineItemBodyPropTypes {
  children: React.ReactNode
  isLastStep?: boolean
}

interface TimelinePropTypes {
  children: React.ReactNode
}

export const TimelineItemHeader = ({children}: TimelineItemHeaderPropTypes) => (
  <TitleContainer>
    <Circle />
    <StepTitle>
      <Heading appearance="title2" marginBottomSize="s000">
        {children}
      </Heading>
    </StepTitle>
  </TitleContainer>
)

export const TimelineItemBody = ({
  children,
  isLastStep = false
}: TimelineItemBodyPropTypes) => (
  <StepDescription>
    <Line isLastStep={isLastStep} />
    <StepTextContainer>
      <Text
        marginTopSize="s300"
        marginBottomSize="s600"
        colorPath="midnight.m600"
      >
        {children}
      </Text>
    </StepTextContainer>
  </StepDescription>
)

export const Timeline = ({children}: TimelinePropTypes) => (
  <TimelineContainer>{children}</TimelineContainer>
)

export default Timeline
